import * as React from "react";
import { FavoritesIcon } from "../FavoritesIcon";
import { MarketsCount } from "../MarketsCount";
const MarketsCountLink = props => {
    return (React.createElement("a", { href: props.linkUrl, onClick: props.eventCardHandler, className: `rj-ev-list__${props.componentPrefix}__section rj-ev-list__${props.componentPrefix}__section--counter`, "data-uat": `a-ev-list-${props.componentPrefix}-section-counter` },
        props.isFavoritesEnabled &&
            React.createElement(FavoritesIcon, { isInFavorites: props.isInFavorites, favoritesHandler: props.favoritesHandler }),
        React.createElement(MarketsCount, { count: props.marketsCount, componentPrefix: props.componentPrefix })));
};
MarketsCountLink.displayName = "MarketsCountLink";
export default React.memo(MarketsCountLink);
//# sourceMappingURL=MarketsCountLink.js.map